import { createSlice } from '@reduxjs/toolkit';
import { get } from 'lodash';

import type { PayloadAction } from '@reduxjs/toolkit';
import { SIMILAR_PACKAGES_STATE } from '../constants/similar-packages';
import { actualizePackageFail } from '../actions/actualization';

import type { SimilarPackagesStateType } from '../similarPackages/types';

const initialState: SimilarPackagesStateType = {
  state: SIMILAR_PACKAGES_STATE.INITIAL,
  tours: [],
  adjust: {},
  failed: false,
  excludeCurrentOperator: null,
  isPopupOpened: false,
  newRequestId: null,
};

const setAdjust = (
  field: string,
  state: SimilarPackagesStateType,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: any,
) => {
  const { adjust } = state;

  return {
    ...state,
    state: SIMILAR_PACKAGES_STATE.PREPARE,
    adjust: {
      ...adjust,
      [field]: payload,
    },
  };
};

const similarPackagesSlice = createSlice({
  name: 'similarPackages',
  initialState,
  reducers: {
    similarPackagesStart: (state) => ({
      ...state,
      state: SIMILAR_PACKAGES_STATE.PERFORMING,
    }),
    similarPackagesCreatedRequest: (
      state,
      { payload }: { type: string; payload: string },
    ) => ({
      ...state,
      newRequestId: payload,
    }),
    similarPackagesPopupOpened: (state) => ({
      ...state,
      isPopupOpened: true,
    }),
    similarPackagesPopupClosed: (state) => ({
      ...state,
      isPopupOpened: false,
    }),
    similarPackagesFinish: (
      state,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      { payload }: { type: string; payload: any },
    ) => {
      const {
        state: status,
        tours,
        hotel_offers_count: hotelOffersCount,
      } = payload;

      return {
        ...state,
        state: status,
        tours,
        hotelOffersCount,
      };
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
    similarPackagesFail: (state, _: PayloadAction<any>) => ({
      ...state,
      failed: true,
      state: SIMILAR_PACKAGES_STATE.NO_RESULTS,
    }),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
    createPackageAction: (state, _: PayloadAction<any>) => ({
      ...state,
      state: SIMILAR_PACKAGES_STATE.REDIRECT,
    }),
    createPackageFail: (state) => ({
      ...state,
      state: SIMILAR_PACKAGES_STATE.NO_RESULTS,
      failed: true,
    }),
    setSearcherDate: (state, { payload }: { type: string; payload: string }) =>
      setAdjust('date', state, payload),
    setAdults: (state, { payload }: { type: string; payload: number }) =>
      setAdjust('adults', state, payload),
    setKids: (state, { payload }: { type: string; payload: number[] }) =>
      setAdjust('kidsAges', state, payload),
    setNights: (state, { payload }: { type: string; payload: number }) =>
      setAdjust('nights', state, payload),
    clearSearch: () => initialState,
  },
  extraReducers: (builder) =>
    builder.addCase(actualizePackageFail, (state, { payload }) => {
      const defaultValue = true;
      const excludeCurrentOperator = get(
        payload,
        'exclude_operator',
        defaultValue,
      );

      return {
        ...state,
        excludeCurrentOperator,
      };
    }),
});

export const {
  similarPackagesStart,
  similarPackagesCreatedRequest,
  similarPackagesPopupOpened,
  similarPackagesPopupClosed,
  similarPackagesFinish,
  similarPackagesFail,
  createPackageAction,
  createPackageFail,
  setSearcherDate,
  setAdults,
  setKids,
  setNights,
  clearSearch,
} = similarPackagesSlice.actions;
export default similarPackagesSlice.reducer;
